/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {OptionModel} from '../../../../model'
import {getOption} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useApplication} from '../../../../hooks'

const TableOption: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const {module, getModuleList} = useApplication()

  const getOptionList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getOption(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getModuleList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getOptionList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getOptionList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])

  const handleViewPanel = (rowData: any) => {
    const getRow = rowData.row
    const getArrows = rowData.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-option',
      },
      idToEdit: getData.id,
      idToDelete: '',
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        option: {
          applicationName: getData.aplicacion,
          optionName: getData.nombre,
        },
      },
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<OptionModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            disable={!props.data[props.row.index].flagActions}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Módulo'
            data={module}
            name='aplicacionId'
            selecteable
          />
        ),
        accessor: 'aplicacion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Opción' name='nombre' searcheable />
        ),
        accessor: 'nombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}{' '}
          </>
        ),
      },
    ],
    [module, selectedOn],
  )

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      <KTCard shadow className='w-100'>
        <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

export {TableOption}
